import React, { useState } from "react";
import { useNavigation } from "@react-navigation/native";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import Button from "theme/Button";
import ThemedBlockTitle from "components/atoms/ThemedBlockTitle";
import CacheStorage from "utils/cache/CacheStorage";
import store from "services/redux/store";
import _ from "lodash";
import CacheByUpdatedAt from "utils/cache/CacheByUpdatedAt";
import { AppRoutes } from 'navigations/app-routes'
import Text from "theme/Text";
import PushNotificationService from 'services/push-notifications/service'
import AppUpdater from 'services/app-updater'
import AccountStorage from 'utils/accounts/AccountStorage'
import i18n from 'utils/i18n'
import { StyleSheet, View } from 'react-native'
import { MODE_SCAN_IN } from 'utils/constants/qrcode-constants'

const HomeMoreDebugScene = () => {
	
	const navigation = useNavigation();
	
	const [ cacheSize, setCacheSize ] = useState( '?' )
	const [ token, setToken ] = useState( null )
	const [ tokenErrors, setTokenErrors ] = useState( '' )
	const [ textErrors, setTextErrors ] = useState( '' )
	const [ updateErrors, setUpdateErrors ] = useState( [] )
	
	const [ accounts, setAccounts ] = useState( [] )
	const [ accountErrors, setAccountErrors ] = useState( [] )
	const [ accountDebugs, setAccountDebugs ] = useState( [] )
	
	const navigateToInterfaceIcons = () => {
		navigation.navigate( AppRoutes.MORE_DEBUG_INTERFACE_ICONS );
	}
	
	const navigateToLunchScanner = () => {
		navigation.navigate( AppRoutes.LUNCH_SCANNER );
	}
	
	const navigateToDebugVideo = () => {
		navigation.navigate( AppRoutes.MORE_DEBUG_VIDEO );
	}
	
	const onPressNavigateBookingComplete = () => {
		//navigation.navigate( AppRoutes.ADD_BOOKING_SUCCESS );
		
		navigation.navigate( AppRoutes.ADD_BOOKING, {
			screen: AppRoutes.ADD_BOOKING_SUCCESS,
			params: {
				disableTimer: true
			}
		})
	}
	
	const navigateToTransportSelect = () => {
		navigation.navigate( AppRoutes.PRESENCE_TRANSPORT, {
			navigatedFromScan: false,
			scanMode: MODE_SCAN_IN,
			//message: i18n.t( `notification.scan_success.${ MODE_SCAN_IN }` ),
			//buildingGuid: buildingGuid
		});
	}
	
	const getNewCacheUpdatedAt = () => {
		CacheByUpdatedAt.backgroundReload();
	}
	
	const writeCacheUpdatedAtToConsole = () => {
		CacheByUpdatedAt.writeToConsole();
	}
	
	const calculateCacheSize = () => {
		CacheStorage.calculateCacheStorage( true ).then( ( result ) => {
			setCacheSize( result )
		});
	}
	
	const writeCacheToConsole = () => {
		CacheStorage.writeToConsole();
	}
	
	const clearCache = () => {
		CacheStorage.clearCache().then( this.calculateCacheSize );
	}
	
	const writeReduxDataToConsole = () => {
		_.forEach( store.getState().data, ( data, key ) => {
			console.prefix( `Redux::writeReduxDataToConsole ${key}`, data );
		});
	}
	
	const writeReduxCartToConsole = () => {
		_.forEach( store.getState().cart, ( data, key ) => {
			console.prefix( `Redux::writeReduxCartToConsole ${key}`, data );
		});
	}
	
	const writeReduxDesignToConsole = () => {
		_.forEach( store.getState().design, ( data, key ) => {
			console.prefix( `Redux::writeReduxDesignToConsole ${key}`, data );
		});
	}
	
	const onPressNotificationToken = () => {
		PushNotificationService
			.register()
            .then( result => {
				setToken( result.token )
			})
			.finally( () => {
				setTokenErrors( JSON.stringify( PushNotificationService.errors ) )
			})
	}
	
	const onPressCheckUpdate = async () => {
		const appUpdater = new AppUpdater();
		
		await appUpdater.check({ force: true });
		
		let text = i18n.t( 'debug_ui.no_update' );
		if( appUpdater.updateIsAvailable ) {
			await appUpdater.fetch();
			
			// Get the fetch result form the updater
			text = appUpdater.fetchResult;
		}
		
		setTextErrors(text )
		setUpdateErrors( appUpdater.getErrors() )
	}
	
	const onPressAccounts = async () => {
		const accounts = await AccountStorage.getAccounts()
		
		setAccounts( accounts )
		setAccountErrors( AccountStorage.getErrors() )
		setAccountDebugs( AccountStorage.debug )
	}
	
	return (
		<ThemedSafeAreaComponentTop
			top={false}>
			
			<ThemedLayout
				topNavigation={ true }
				showBackButton={ true }
				footerBar={ false }
				title={ i18n.t( 'debug_ui.title' ) }>
				
				<View style={ staticStyles.viewPadding15 }>
					<ButtonBlock title={ i18n.t( 'debug_ui.pages' ) }>
						<Button onPress={ navigateToLunchScanner }>{ i18n.t( 'titles.more_lunch_scanner') }</Button>
						<Button onPress={ onPressNavigateBookingComplete }>{ i18n.t( 'titles.booking_success') }</Button>
						<Button onPress={ navigateToTransportSelect }>{ i18n.t( 'debug_ui.transport_select' ) }</Button>
					</ButtonBlock>
					
					<ButtonBlock title={ i18n.t( 'debug_ui.interface_tests' ) }>
						<Button onPress={ navigateToInterfaceIcons }>{ i18n.t( 'debug_ui.icons' ) }</Button>
						<Button onPress={ navigateToDebugVideo }>{ i18n.t( 'debug_ui.video' ) }</Button>
					</ButtonBlock>
					
					<ButtonBlock title={ i18n.t( 'debug_ui.cache' ) }>
						<Button onPress={ calculateCacheSize }>{ i18n.t( 'debug_ui.cache_size', { size: cacheSize } ) }</Button>
						<Button onPress={ writeCacheToConsole }>{ i18n.t( 'debug_ui.write_console' ) }</Button>
						<Button onPress={ clearCache }>{ i18n.t( 'debug_ui.clear' ) }</Button>
					</ButtonBlock>
					
					<ButtonBlock title={ i18n.t( 'debug_ui.cache_updated_at' ) }>
						<Button onPress={ writeCacheUpdatedAtToConsole }>{ i18n.t( 'debug_ui.write_console' ) }</Button>
						<Button onPress={ getNewCacheUpdatedAt }>{ i18n.t( 'debug_ui.refresh_cache_timestamp' ) }</Button>
					</ButtonBlock>
					
					<ButtonBlock title={ i18n.t( 'debug_ui.redux' ) }>
						<Button onPress={ writeReduxDataToConsole }>{ i18n.t( 'debug_ui.write_data' ) }</Button>
						<Button onPress={ writeReduxCartToConsole }>{ i18n.t( 'debug_ui.write_cart' ) }</Button>
						<Button onPress={ writeReduxDesignToConsole }>{ i18n.t( 'debug_ui.write_design' ) }</Button>
					</ButtonBlock>
					
					<ButtonBlock title={ i18n.t( 'debug_ui.push_notifications' ) }>
						<Button onPress={ onPressNotificationToken }>{ i18n.t( 'debug_ui.get_token' ) }</Button>
						<Text>{ token }</Text>
						<Text>{ tokenErrors }</Text>
					</ButtonBlock>
					
					<ButtonBlock title={ i18n.t( 'debug_ui.update_errors' ) }>
						<Button onPress={ onPressCheckUpdate }>{ i18n.t( 'debug_ui.check_update_errors' ) }</Button>
						<Text>{textErrors}</Text>
						{ _.map( updateErrors, ( error, index ) => {
							return <Text>{ i18n.t( 'debug_ui.error', { message: error } ) }</Text>;
						}) }
					</ButtonBlock>
					
					<ButtonBlock title={ i18n.t( 'debug_ui.account_errors' ) }>
						<Button onPress={ onPressAccounts }>{ i18n.t( 'debug_ui.check_account_errors' ) }</Button>
						{ _.map( accounts, ( account, index ) => {
							return <Text>{ i18n.t( 'debug_ui.account', { domain: account.domain, name: account.employee_name } ) }</Text>;
						}) }
						{ _.map( accountDebugs, ( value, index ) => {
							return <Text>{ i18n.t( 'debug_ui.debug', { message: value } ) }</Text>;
						}) }
						{ _.map( accountErrors, ( value, index ) => {
							return <Text>{ i18n.t( 'debug_ui.error', { message: value } ) }</Text>;
						}) }
					</ButtonBlock>
				</View>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	);
}

const ButtonBlock = ({ title, children }) => {
	
	return (
		<View
			style={staticStyles.viewMarginBottom12}>
			
			<ThemedBlockTitle style={staticStyles.themedBlockTitleMarginBottom0}>{ title }</ThemedBlockTitle>
			{ children }
		</View>
	)
}

const staticStyles = StyleSheet.create({
	viewPadding15: {
		padding: 15,
	},
	viewMarginBottom12: {
		marginBottom: 12,
	},
	themedBlockTitleMarginBottom0: {
		marginBottom: 0,
	},
});

export default HomeMoreDebugScene
